var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2157",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41316",
    "data-name": "Group 41316",
    transform: "translate(18959 2638)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15676",
    "data-name": "Rectangle 15676",
    width: 24,
    height: 24,
    transform: "translate(-18959 -2638)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2151",
    transform: "translate(-18957.5 -2636.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2155",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2161",
    transform: "translate(0.611 0.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2163",
    d: "M-622.9-311.448a9.884,9.884,0,0,1-9.823,9.884h-.062a9.885,9.885,0,0,1-9.885-9.885,9.885,9.885,0,0,1,9.885-9.885h.062A9.884,9.884,0,0,1-622.9-311.448Z",
    transform: "translate(642.665 321.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2165",
    transform: "translate(9.413 5.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2167",
    d: "M-71.479-35.744v4.694a1.134,1.134,0,0,1-1.134,1.134h-.031a1.13,1.13,0,0,1-.772-.332,1.131,1.131,0,0,1-.332-.8v-4.694a1.134,1.134,0,0,1,1.1-1.134h.031A1.134,1.134,0,0,1-71.479-35.744Z",
    transform: "translate(73.748 36.879)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2169",
    transform: "translate(9.507 13.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2171",
    d: "M-65.59-32.8a1.041,1.041,0,0,1-1.041,1.041A1.041,1.041,0,0,1-67.672-32.8a1.041,1.041,0,0,1,1.041-1.041A1.041,1.041,0,0,1-65.59-32.8Z",
    transform: "translate(67.672 33.836)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircleOutlined);
export default __webpack_public_path__ + "static/media/warning-circle-outlined.1afb74e7349a0ee37034a70040b2a8d7.svg";
export { ForwardRef as ReactComponent };